<template>

  <div>

    <day-hours-editor v-model="value.monday" title="Monday" />
    <day-hours-editor v-model="value.tuesday" title="Tuesday" />
    <day-hours-editor v-model="value.wednesday" title="Wednesday" />
    <day-hours-editor v-model="value.thursday" title="Thursday" />
    <day-hours-editor v-model="value.friday" title="Friday" />
    <day-hours-editor v-model="value.saturday" title="Saturday" />
    <day-hours-editor v-model="value.sunday" title="Sunday" />

  </div>

</template>
<script>
import DayHoursEditor from './DayHoursEditor';

export default {
  props: ['value'],
  components: {
    DayHoursEditor
  },
  mounted() {

  }
};
</script>



// WEBPACK FOOTER //
// HoursEditor.vue?59bcfdfe